import Vue from 'vue'
import VueRouter from 'vue-router'
import QuickSearch from '../views/QuickSearch'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: QuickSearch
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
